var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FacilityCode",style:(_vm.proMode ? 'background-color:rgb(33,33,33)' : 'white')},[_c('QAReviewer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }